import { UserChatItem } from '@akin-home/chat';
import { ChatAPIOutput } from '@akin-home/chat/frontend';
import { OpenWeatherV2Response } from '@akin-home/weather';
import {
  ChatCalendarItem,
  ChatCalendarItemData,
  ChatCheckListItem,
  ChatClockItem,
  ChatImageItem,
  ChatItemTypes,
  ChatOption,
  ChatOptionsItem,
  ChatRecipeItem,
  ChatRecipeItemData,
  ChatTextItem,
  ChatWeatherItem,
} from './types';

/** Creates a basic chat text item */
export const createChatTextItem = (
  input?: Partial<ChatTextItem>
): ChatTextItem => ({
  type: ChatItemTypes.TEXT,
  data: {
    text: '',
    source: 'client',
  },
  timestamp: new Date().toISOString(),
  ...input,
});

export const chatAPIOutputToTextItem = (
  output: ChatAPIOutput
): ChatTextItem | undefined => {
  if (!output.value) return;

  return {
    type: ChatItemTypes.TEXT,
    data: {
      text: output.value,
      source: 'server',
      options: output.options,
      image_url: output.image_url,
      multiple_choice_options: output.multiple_choice_options,
    },
    timestamp: new Date().toISOString(),
  };
};

export const createInputChatItem = (text = ''): UserChatItem => ({
  type: ChatItemTypes.USER,
  text,
  timestamp: new Date().toISOString(),
});

export const createOutputTextItem = (
  text = '',
  data?: Partial<ChatTextItem['data']>
): ChatTextItem =>
  createChatTextItem({ data: { text, source: 'server', ...data } });

export const createOptionsChatItem = (
  description: string,
  options: ChatOption[]
): ChatOptionsItem => ({
  type: ChatItemTypes.OPTIONS,
  data: {
    description,
    options,
  },
  timestamp: new Date().toISOString(),
});

export const createImageChatItem = (
  data: Partial<{
    title?: string;
    description?: string;
    source: string;
  }>
): ChatImageItem => ({
  data: { ...data, source: '' },
  type: ChatItemTypes.IMAGE,
  timestamp: new Date().toISOString(),
});

export const createCalendarChatItem = (
  data: ChatCalendarItemData
): ChatCalendarItem => ({
  data,
  type: ChatItemTypes.CALENDAR_ITEM,
  timestamp: new Date().toISOString(),
});

export const createWeatherChatItem = (
  weather_data: OpenWeatherV2Response
): ChatWeatherItem => ({
  data: {
    weather_data,
  },
  type: ChatItemTypes.WEATHER,
  timestamp: new Date().toISOString(),
});

export const createClockChatItem = (
  location?: string,
  date?: string,
  time?: string
): ChatClockItem => ({
  data: {
    location,
    date,
    time,
  },
  type: ChatItemTypes.CLOCK,
  timestamp: new Date().toISOString(),
});

/** Creates a checklist chat item */
export const createChecklistChatItem = (id: string): ChatCheckListItem => ({
  type: ChatItemTypes.CHECKLIST,
  data: {
    id,
  },
  timestamp: new Date().toISOString(),
});

export const createRecipeChatItem = (
  data: ChatRecipeItemData
): ChatRecipeItem => ({
  data,
  type: ChatItemTypes.RECIPE_ITEM,
  timestamp: new Date().toISOString(),
});
